var map = {
	"./bg07.png": 83184,
	"./br/PT/S1/bg07.png": 41817,
	"./in/EN/S1/bg07.png": 6838,
	"./ph/EN/S1/bg07.png": 12631,
	"./vn/VI/S1/bg07.png": 19714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96214;